"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledFileName = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var _styleConsts = require("../utils/styleConsts");

var fileNameStyles = function fileNameStyles(_ref) {
  var color = _ref.theme.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("color:", color.accent, ";font-weight:", _styleConsts.font.weight.bold, ";")
  );
};

var StyledFileName = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("span", {
  target: "css-umy4va0"
})(fileNameStyles));
exports.StyledFileName = StyledFileName;

var wrapperStyles = function wrapperStyles(_ref2) {
  var color = _ref2.theme.color,
      expanded = _ref2.expanded;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("fill:", color.accent, ";.IconArrow{fill:", color.accent, ";", expanded && "\n        transform: rotate(180deg);\n    ", "}")
  );
};

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-umy4va1"
})(wrapperStyles));

exports.default = _default;